import { RichText, Picture, PictureProps } from 'ui/components';
import { LinkButtonFeature } from 'features/Modules/Linkbutton';
import styles from './ImageCampaign.module.scss';
import classNames from 'classnames';

export interface ImageCampaignProps {
    picture: PictureProps;
    text: string;
    cTALink: {
		url: string;
		name?: string;
		target?: string;
	};
    boxColor: string;
    textColor: string;
    imageWidthPercentage: number;
    moduleHeightPixels: number;
    overridePaddingVertical?: number;
    overridePaddingHorizontal?: number;
    verticalPlacement?: "Top" | "Midten" | "Bund";
}

export const ImageCampaign: React.FC<ImageCampaignProps> = ({ picture, text, cTALink, boxColor, textColor, imageWidthPercentage, moduleHeightPixels, overridePaddingVertical, overridePaddingHorizontal, verticalPlacement = "Midten" }) => {
    
    const paddingVertical = overridePaddingVertical > 0 ? overridePaddingVertical : 15;
    const paddingHorizontal = overridePaddingHorizontal > 0 ? overridePaddingHorizontal : 15;
    const padding = `${paddingVertical}% ${paddingHorizontal}%`;

    const getVerticalAlignment = () => {
        switch (verticalPlacement) {
            case "Top":
            return "flex-start";
            case "Bund":
            return "flex-end";
            case "Midten":
            default:
            return "center";
        }
    };

	return (
		<div className={classNames(styles.gridish)}
			style={{
				'--image-width': `${imageWidthPercentage > 0 ? imageWidthPercentage : 50}%`,
                '--module-height': `${moduleHeightPixels > 0 ? moduleHeightPixels : 500}px`,
			} as React.CSSProperties}>
            {picture && (
                <div>
                    <Picture {...picture} aspectRatio={0.8}/>
                </div>
            )}
            <div className={styles.textbox} style={{ backgroundColor: boxColor && isValidHex(boxColor) ? boxColor : undefined ,
					"--vertical-alignment": getVerticalAlignment()} as React.CSSProperties }>
                <div style={{padding: padding, overflow:"hidden"}}>
                    <RichText content={text} textColor={textColor} >
                    </RichText>
                    {cTALink && (
                        <LinkButtonFeature className={styles.button} {...cTALink} style="secondary" >
                            {cTALink.name}
                        </LinkButtonFeature>
                    )}
                </div>
            </div>
        </div>
	)
};

const isValidHex = (color: string) => /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(color);
